export default __webpack_public_path__ + "static/media/resume.ab99441b.pdf";